import type { SalesBeneficiary } from 'models/forms/SalesBeneficiary';
import type { Item } from 'models/IItem';
import { useContext } from 'react';

import { AddonMainFormContext } from '../AddonMainForm.context';
import { ListField } from './ListField';

type OwnProps = {
  value?: string;
  availableItems?: Item<SalesBeneficiary>[];
  onChange: (newValue: string) => void;
};

export function SalesBeneficiary({ value, availableItems, onChange }: OwnProps) {
  const { isLoading, isReadOnly } = useContext(AddonMainFormContext);
  const availableSalesBeneficiaries: readonly Item[] =
    availableItems?.map(salesBeneficiary => ({
      value: salesBeneficiary.value.rtfeLogin,
      label: salesBeneficiary.label,
    })) ?? [];
  return (
    <ListField
      id="salesBeneficiary"
      disabled={isReadOnly}
      isLoading={isLoading}
      translationKey="addon.SalesBeneficiary"
      availableItems={availableSalesBeneficiaries}
      value={value ?? ''}
      onValueChange={onChange}
    />
  );
}
